import { t } from '@lingui/core/macro';
import type { NoddiAsyncError } from 'noddi-types';
import { NoddiButton } from 'noddi-ui-web';
import { ApiErrorMessageWithTrans } from '../Error/ApiErrorMessageWithTrans';

type Props = {
  question: string;
  error: NoddiAsyncError | null;
  isRemoving: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

/** Two-step removal inside a list row — a nested dialog on top of the prompt is one layer too many. */
export const InlineRemovalConfirm = ({ question, error, isRemoving, onCancel, onConfirm }: Props) => (
  <div className='flex flex-col gap-2'>
    {error && <ApiErrorMessageWithTrans error={error} />}
    <div className='flex flex-wrap items-center justify-between gap-2'>
      <p className='text-sm'>{question}</p>
      <div className='flex gap-2'>
        <NoddiButton variant='outline' size='small' onClick={onCancel}>
          {t`Cancel`}
        </NoddiButton>
        <NoddiButton variant='destructive' size='small' loading={isRemoving} onClick={onConfirm}>
          {t`Remove`}
        </NoddiButton>
      </div>
    </div>
  </div>
);
